module.exports = __webpack_public_path__ + "img/64.350f1d9d.webp";